import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/Macro/MainTable/MainTable';
import { useMessages } from './messStore';

function Messages(props) {
    let { messages, columns, getMessages, deleteMessage } = useMessages()
    useEffect(() => {
        getMessages()
    }, [])
    return (
        <div>
            <MainTable 
                pageTitle={"Xabarlar"}
                pcolumns={columns}
                pdata={messages}
                defkey={'id'}
                onDelete={(_,id)=>deleteMessage(id)}
            />
        </div>
    );
}

export default Messages;